exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._17CT0DG1jiRKar-LRwPaqV{-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative}html[dir=ltr] ._17CT0DG1jiRKar-LRwPaqV{border-right:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir=rtl] ._17CT0DG1jiRKar-LRwPaqV{border-left:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] ._17CT0DG1jiRKar-LRwPaqV:last-child{border-right:0}html[dir=rtl] ._17CT0DG1jiRKar-LRwPaqV:last-child{border-left:0}", ""]);

// exports
exports.locals = {
	"itemsPanelHeader": "_17CT0DG1jiRKar-LRwPaqV"
};